module.exports = __webpack_public_path__ + "static/media/moons.189adfeb.svg";